// @flow
import type { ContractsActionType } from './actions';

const initialState = {};

const contractsReducer = (state: Object = initialState, action: ContractsActionType) => {
  switch (action.type) {
    case 'FETCH_CONTRACTS_SUCCESS':
      return {
        ...state,
        ...action.payload.contracts,
      };
    default:
      return state;
  }
};

export default contractsReducer;
